module.exports = __webpack_public_path__ + "img/crown_brown.825757db.svg";